import { DeliveryActionProps, useDeliveryAction } from '../../../../details/actions/delivery/delivery-action.hook';
import { DeliverNowModalContent } from '../../../../details/actions/delivery/components/deliver-now-modal-content';

export function DeliverNowStep(props: DeliveryActionProps) {
  const hook = useDeliveryAction(props);

  return <DeliverNowModalContent {...hook} order={props.order} showRecipientSummary showBookingConfirmationAlert />;
}
